module.exports = __webpack_public_path__ + "img/Weapon_260.0b4207d0.png";